import Wrapper from './wrapper';
import {
  ICorrectionCreateParams,
  ICorrectionListParams,
  ICorrectionListResponse,
  IWrapper,
} from './types';
import { ICorrection } from '../types/my-types';

class Correction {
  wrapper: IWrapper;
  /**
   * @param {Wrapper} wrapper
   */
  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }
  list(params: ICorrectionListParams) {
    return this.wrapper.client.get<ICorrectionListResponse, ICorrectionListResponse>(
      `data-pools/${this.wrapper.dataPoolId}/corrections/`,
      { params }
    );
  }
  retrieve(id: string) {
    return this.wrapper.client.get<ICorrection, ICorrection>(
      `data-pools/${this.wrapper.dataPoolId}/corrections/${id}/?advanced=true`
    );
  }
  create(data: ICorrectionCreateParams, syncValidation: boolean) {
    const sync = syncValidation ? '&sync=true' : '';
    return this.wrapper.client.post<ICorrection, ICorrection>(
      `data-pools/${this.wrapper.dataPoolId}/corrections/?advanced=true${sync}`,
      data
    );
  }
  del(id: string) {
    return this.wrapper.client.delete(
      `data-pools/${this.wrapper.dataPoolId}/corrections/${id}/?advanced=true`
    );
  }
}

export default Correction;
